import type { ServicePartnerPageDetailsDto } from "@/api/types";
import { useTranslation } from "@/translations";

import { IntegrationAccessButton } from "../IntegrationAccessButton";
import { ServiceDetailsBlockCard } from "../ServiceDetailsBlockCard";

interface BringmeDetailsViewProps {
  serviceDetails: ServicePartnerPageDetailsDto;
}

export function BringmeDetailsView({ serviceDetails }: BringmeDetailsViewProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <ServiceDetailsBlockCard title={t("page.service-details.bringme.title")}>
      <IntegrationAccessButton servicePartnerId={serviceDetails.id} label={t("page.service-details.bringme.access")} />
    </ServiceDetailsBlockCard>
  );
}
